import { ReactNode } from 'react';
import { validateContent } from '../api/ValidationUtil';
import { ContentValidatorContext } from './ContentValidatorContext';

/**
 * Provide the `validateContent()` function so it can be into the ContentEditorService.
 * That function cannot be imported directly because it imports CloudScape which
 * break unit tests.
 */
export function ContentValidatorProvider({ children }: { children: ReactNode }) {
  return (
    <ContentValidatorContext.Provider value={validateContent}>
      {children}
    </ContentValidatorContext.Provider>
  );
}
